"use client";
import { useState } from "react";

import useIsomorphicLayoutEffect from "./useIsomorphicLayoutEffect";
import useEventListener from "./useEventListener";

interface WindowSize {
  width: number;
  height: number;
}

function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
  });

  const handleSize = () => {
    if (typeof window !== "undefined") {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
  };

  //Define empty fallback function if window is undefined
  const noop = () => {};
  useEventListener("resize", typeof window !== "undefined" ? handleSize : noop);

  // Set size at the first client-side load
  useIsomorphicLayoutEffect(() => {
    if (typeof window !== "undefined") {
      handleSize();
    }
  }, []);

  return windowSize;
}

export default useWindowSize;
